// Ported 1:1 from src/lib/whatsapp.ts. The cart lives client-side, so the
// checkout message (and its total, discount-aware) can only be built here —
// see app/lib/whatsapp.rb for the server-rendered single-book variants used
// by the book detail page's sold-out CTA (same three message variants).
import { formatCurrency } from "./format"

export const WHATSAPP_NUMBER = "559388024327"
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`

export function buildBookWhatsAppMessage(book) {
  if (book.is_pre_order) {
    return `Olá! Quero reservar o livro "${book.title}" de ${book.author} (Nº ${book.internal_code}) que está em pré-venda.`
  }
  if (book.quantity === 0) {
    return `Olá! Vi que o livro "${book.title}" de ${book.author} (Nº ${book.internal_code}) está esgotado. Têm previsão de voltar?`
  }
  return `Olá! Vi o livro "${book.title}" de ${book.author} (Nº ${book.internal_code}) no site. Ainda está disponível?`
}

export function buildBookWhatsAppUrl(book) {
  return `${WHATSAPP_URL}?text=${encodeURIComponent(buildBookWhatsAppMessage(book))}`
}

// `fulfillment` is null whenever the storefront had no pickup event to offer —
// the message then carries no line about it, exactly as before the events
// feature existed. When present it is { kind: "evento", label } or
// { kind: "entrega" }, and the label arrives already formatted from
// EventBanner#pickup_label, so no date formatting happens in the browser.
//
// Note for WhatsappOrderParser (app/lib/whatsapp_order_parser.rb), which reads
// this message back in the admin: it only picks up lines matching /#(\d+)/, so
// the line added here is ignored as long as an event name carries no "#123".
export function buildCartWhatsAppMessage(items, promo, fulfillment = null) {
  const lines = [ "Olá! Gostaria de comprar os seguintes livros:", "" ]
  for (const item of items) {
    const code = item.internal_code != null ? `#${item.internal_code} ` : ""
    const freeUnits = Math.min(promo.freeUnitsByLineId.get(item.id) ?? 0, item.quantity)
    const paidUnits = item.quantity - freeUnits

    if (paidUnits > 0) {
      const qty = paidUnits > 1 ? ` (x${paidUnits})` : ""
      lines.push(`- ${code}${item.title} - ${item.author} - ${formatCurrency(item.price)}${qty}`)
    }
    if (freeUnits > 0) {
      const qty = freeUnits > 1 ? ` (x${freeUnits})` : ""
      lines.push(`- ${code}${item.title} - ${item.author} - GRÁTIS (promoção)${qty}`)
    }
  }
  lines.push("")
  const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0) - promo.discountTotal
  lines.push(`Total: ${formatCurrency(total)}`)

  if (fulfillment) {
    lines.push(fulfillment.kind === "evento"
      ? `Retirada: ${fulfillment.label}`
      : "Entrega: combinar pelo WhatsApp")
  }

  return lines.join("\n")
}

export function buildCartWhatsAppUrl(items, promo, fulfillment = null) {
  return `${WHATSAPP_URL}?text=${encodeURIComponent(buildCartWhatsAppMessage(items, promo, fulfillment))}`
}
